"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicProductGroup = exports.getPublicProductGroups = exports.deleteProductGroupRelation = exports.postProductGroupRelation = exports.putProductGroupOrganization = exports.putProductGroupAccessibility = exports.deleteProductGroupPermission = exports.postProductGroupPermission = exports.putProductGroupAction = exports.postProductGroup = exports.putProductGroup = exports.getProductGroup = exports.getProductGroups = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var productGroupsAuthorizedPath = root_1.pimAuthorized + '/productGroups/';
var productGroupsPublicPath = root_1.pimPublic + '/productGroups/';

var getProductGroups = function getProductGroups(authentication, queryParameters) {
  return common_1.get(authentication, productGroupsAuthorizedPath, queryParameters);
};

exports.getProductGroups = getProductGroups;

var getProductGroup = function getProductGroup(authentication, id) {
  return common_1.get(authentication, productGroupsAuthorizedPath + id);
};

exports.getProductGroup = getProductGroup;

var putProductGroup = function putProductGroup(authentication, productGroup) {
  return common_1.put(authentication, productGroupsAuthorizedPath + productGroup.id, productGroup);
};

exports.putProductGroup = putProductGroup;

var postProductGroup = function postProductGroup(authentication, productGroup) {
  return common_1.post(authentication, productGroupsAuthorizedPath, productGroup);
};

exports.postProductGroup = postProductGroup;

var putProductGroupAction = function putProductGroupAction(authentication, id, action, data) {
  return common_1.putSub(authentication, productGroupsAuthorizedPath, id, action, data);
};

exports.putProductGroupAction = putProductGroupAction;

var postProductGroupPermission = function postProductGroupPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, productGroupsAuthorizedPath, id, permission);
};

exports.postProductGroupPermission = postProductGroupPermission;

var deleteProductGroupPermission = function deleteProductGroupPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, productGroupsAuthorizedPath, id, permissionId);
};

exports.deleteProductGroupPermission = deleteProductGroupPermission;

var putProductGroupAccessibility = function putProductGroupAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, productGroupsAuthorizedPath, id, accessibility);
};

exports.putProductGroupAccessibility = putProductGroupAccessibility;

var putProductGroupOrganization = function putProductGroupOrganization(authentication, id, accessibility) {
  return common_1.putEntityOrganization(authentication, productGroupsAuthorizedPath, id, accessibility);
};

exports.putProductGroupOrganization = putProductGroupOrganization;

var postProductGroupRelation = function postProductGroupRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, productGroupsAuthorizedPath, id, relation);
};

exports.postProductGroupRelation = postProductGroupRelation;

var deleteProductGroupRelation = function deleteProductGroupRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, productGroupsAuthorizedPath, id, relationId);
};

exports.deleteProductGroupRelation = deleteProductGroupRelation;

var getPublicProductGroups = function getPublicProductGroups(authentication, queryParameters) {
  return common_1.get(authentication, productGroupsPublicPath, queryParameters);
};

exports.getPublicProductGroups = getPublicProductGroups;

var getPublicProductGroup = function getPublicProductGroup(authentication, id) {
  return common_1.get(authentication, productGroupsPublicPath + id);
};

exports.getPublicProductGroup = getPublicProductGroup;